import React, { useState, useEffect } from 'react';
import { Modal, Button } from 'react-bootstrap';
import PropTypes from 'prop-types';
import { delay, getErrorMessage } from '../../../../../../utils/helper';
import ModalConfirm from '../../../../../../components/Modal/ConfirmLayouts';
import Loader from '../../../../../../components/Loaders/Loader';
import { ticketFormSubcategoryDelete } from '../../../../../../services/endpoints/settings';

const ModalDeleteSubcategory = ({ data, onHide, onSubmit }) => {
  const [form, setForm] = useState({
    isLoading: false,
    error: null,
    success: false,
  })
  const { isLoading, error, success } = form;

  const [modal, setModal] = useState(null)
  useEffect(() => {
    setModal(data);
  }, [data]);

  const onConfirm = async () => {
    if (modal?.id) {
      const { id } = modal;
      try {
        setForm((prevState) => ({
          ...prevState,
          error: null,
          isLoading: true,
        }));

        await ticketFormSubcategoryDelete(id);

        await setForm((prevState) => ({
          ...prevState,
          success: true,
        }));
        await delay(500);

        onSubmit();
      } catch (error) {
        const errorMessage = getErrorMessage(error);
        setForm((prevState) => ({
          ...prevState,
          isLoading: false,
          error: errorMessage,
        }));
      }
    }
  }

  return (
    <ModalConfirm.Wrapper>
      <Modal.Body>
        <ModalConfirm.TitleDescriptionWrapper>
          {error ? <div className="alert alert-danger">{error}</div> : null}
          {isLoading ? <Loader success={success} /> : null }
          <ModalConfirm.Title>
            Are you sure you want to delete subcategory?
          </ModalConfirm.Title>
          <ModalConfirm.Description>
            <div>Are you sure you want to delete subcategory</div>
            <div>
              <b>{modal?.name}</b>
              ?
            </div>
          </ModalConfirm.Description>
        </ModalConfirm.TitleDescriptionWrapper>
        <ModalConfirm.Actions>
          <Button
            type="submit"
            bsStyle="danger"
            disabled={isLoading}
            onClick={onConfirm}
          >
            <span>Delete</span>
          </Button>
          <Button
            disabled={isLoading}
            onClick={onHide}
          >
            <span>Cancel</span>
          </Button>
        </ModalConfirm.Actions>
      </Modal.Body>
    </ModalConfirm.Wrapper>
  );
};

ModalDeleteSubcategory.propTypes = {
  data: PropTypes.any,
  onHide: PropTypes.func,
  onSubmit: PropTypes.func,
}

export default ModalDeleteSubcategory;
